import WrongDomainNotifier from './WrongDomainNotifier'

export default WrongDomainNotifier
